import omitBy from 'lodash.omitby'

export const removeUndefined = (obj: object) => omitBy(obj, (value) => value === undefined)
